import { cacheGetDefault } from '@/util/cache'
export default {
  methods: {
    async getDictByType(dictType) {
      let that = this
      const data = await cacheGetDefault(dictType, async () => {
        const { data, errorRaw } = await that.getAsync(
          '/system/dict-data/getDictDataListByDictType',
          { dictType },
        )
        if (errorRaw) {
          that.$dialog.message.error(`${dictType}字典获取失败，部分功能受损`)
          return null
        }
        if (data.length === 0) {
          that.$dialog.message.error(`${dictType}数据字典为空，部分功能受损`)
        }
        return data
      })
      return data
    },
  },
}
